import { CollectionStore } from "Helpers/StoreHelper";
import { ExternalChatChannel } from "domain-entities";

export function getExternalActiveUserIds(
  channelsStore: CollectionStore<ExternalChatChannel>
) {
  if (!channelsStore.isLoading && !channelsStore.error) {
    return channelsStore.items
      .map((channel) => channel.usersActive)
      .flat()
      .filter((userId) => userId.startsWith("UE-"))
      .filter((userId, index, userIds) => userIds.indexOf(userId) === index);
  } else {
    return [];
  }
}
